
import React from "react";
import { TextField, MenuItem } from "@material-ui/core";

const ageOperators = [
    { value: "", label: "Seleccionar..." },
    { value: "EQUALS", label: "Igual a" },
    { value: "GT", label: "Mayor a" },
    { value: "LT", label: "Menor a" },
    { value: "BETWEEN", label: "Rango" },
];

const AgeFilter = ({ value, onChange }) => {
    const { operator, ageFrom, ageTo } = value;

    const handleOperatorChange = (newOperator) => {
        if (newOperator === "") {
            onChange({ operator: "", ageFrom: "", ageTo: "" });
        } else if (newOperator === "BETWEEN") {
            onChange({ operator: "BETWEEN", ageFrom: "", ageTo: "" });
        } else {
            onChange({ operator: newOperator, ageFrom: "", ageTo: "" });
        }
    };

    const handleAgeFromChange = (val) => {
        onChange({ ...value, ageFrom: val });
    };

    const handleAgeToChange = (val) => {
        onChange({ ...value, ageTo: val });
    };

    const isRange = operator === "BETWEEN";
    const showSingleInput = operator === "EQUALS" || operator === "GT" || operator === "LT";

    return (
        <div style={{ position: "relative" }}>
            <TextField
                select
                value={operator}
                variant="outlined"
                size="small"
                fullWidth
                onChange={(e) => handleOperatorChange(e.target.value)}
            >
                {ageOperators.map((opt, i) => (
                    <MenuItem key={i} value={opt.value}>
                        {opt.label}
                    </MenuItem>
                ))}
            </TextField>
            {showSingleInput && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: "4px", zIndex: 1 }}>
                    <TextField
                        type="number"
                        value={ageFrom}
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder="Edad"
                        inputProps={{ min: 1, max: 120 }}
                        onChange={(e) => handleAgeFromChange(e.target.value)}
                    />
                </div>
            )}
            {isRange && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: "4px", zIndex: 1, display: "flex", gap: "4px", alignItems: "center" }}>
                    <TextField
                        type="number"
                        value={ageFrom}
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder="Desde"
                        inputProps={{ min: 1, max: 120 }}
                        onChange={(e) => handleAgeFromChange(e.target.value)}
                    />
                    <span>—</span>
                    <TextField
                        type="number"
                        value={ageTo}
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder="Hasta"
                        inputProps={{ min: 1, max: 120 }}
                        onChange={(e) => handleAgeToChange(e.target.value)}
                    />
                </div>
            )}
        </div>
    );
};

export default AgeFilter;
